import Link from "next/link";

export const QueryScheduleText: React.FC = () => {
  return (
    <>
      <p>
        If you want these results to be fresher, you can always{" "}
        <Link href="/docs/query/query-executions/#__tabbed_1_1">
          <a target="_blank">refresh</a>
        </Link>{" "}
        this dashboard or query, by clicking the Run button.
      </p>
      <p>
        If you are the owner, you can also{" "}
        <Link href="/docs/query/query-executions/#__tabbed_1_4">
          <a target="_blank">schedule it</a>
        </Link>{" "}
        to run periodically.
      </p>
      <p>
        See the{" "}
        <Link href="/docs/query/query-executions/">
          <a target="_blank">docs</a>
        </Link>{" "}
        for more info.
      </p>
    </>
  );
};
